import { render, staticRenderFns } from "./storePie.vue?vue&type=template&id=83bb9190&scoped=true&"
import script from "./storePie.vue?vue&type=script&lang=js&"
export * from "./storePie.vue?vue&type=script&lang=js&"
import style0 from "./storePie.vue?vue&type=style&index=0&id=83bb9190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bb9190",
  null
  
)

export default component.exports